import React, { useEffect, useState, useRef } from "react"
const leftButton = require("../images/components/slideshowleft.png")
const rightButton = require("../images/components/slideshowright.png")

interface SlideshowProps {
  images: Array<any>
  captions: Array<any>
}
export const Slideshow: React.FC<SlideshowProps> = ({ images, captions }) => {
  const [slide, setSlide] = useState(0)
  const [fading, setFading] = useState(false)
  function changeSlide(d: number) {
    setFading(true)
    setTimeout(() => {
      setSlide(currSlide => (currSlide + d + images.length) % images.length)
      setFading(false)
    }, 500)
  }
  return (
    <div
      className={fading ? "fadeOut" : "fadeIn"}
      style={{ position: "relative" }}
    >
      <img
        src={images[slide]}
        style={{ width: "100%", display: "block" }}
        alt="Slideshow image"
      />
      <input
        type="image"
        src={leftButton}
        onClick={() => {
          changeSlide(-1)
        }}
        style={{ position: "absolute", left: 0, bottom: "50%" }}
        alt="Slideshow left button"
      />
      <input
        type="image"
        src={rightButton}
        onClick={() => {
          changeSlide(1)
        }}
        style={{ position: "absolute", right: 0, bottom: "50%" }}
        alt="Slideshow right button"
      />

      <div className="floatBox">{captions[slide]}</div>
    </div>
  )
}
